<div class="ts-audit" [class.standalone]="from !== 'timeSheetDetail'">

  <!-- Standalone close button (only when this component is opened on its own) -->
  <div class="ts-audit-standalone-head" *ngIf="isModalCloseIcon">
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Standalone header (job/title context) — hidden inside the timesheet-details modal -->
  <div class="ts-audit-context" *ngIf="from !== 'timeSheetDetail'">
    <div class="ts-audit-context-icon">
      <i [class]="header?.icon || 'bi bi-clock-history'"></i>
    </div>
    <div class="ts-audit-context-text">
      <span class="title">{{ header?.title }}</span>
      <span class="sub" *ngIf="header?.subTitle">{{ header?.subTitle }}</span>
    </div>
  </div>

  <div class="ts-audit-loader" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ul class="ts-trail" *ngIf="!loading && auditTrailActivities?.length">
    <li class="ts-trail-row"
      *ngFor="let activity of auditTrailActivities; let idx = index; let last = last">
      <div class="ts-trail-rail">
        <span class="dot"
          [class.approved]="activity?.new_values?.status === 'Approved'"
          [class.rejected]="activity?.new_values?.status === 'Rejected'"
          [class.pending]="activity?.new_values?.status === 'Pending'"
          [class.submitted]="activity?.new_values?.status === 'Submitted' || !activity?.new_values?.status"></span>
        <span class="line" *ngIf="!last"></span>
      </div>
      <div class="ts-trail-content">
        <div class="when">
          {{ dataSharedService.getFormatedDate(activity.event_date) }} · {{ activity.time }}
        </div>
        <div class="what">
          <strong>{{ activity.user }}</strong> {{ activity.text }}.
        </div>
      </div>
    </li>
  </ul>

  <div class="ts-audit-empty" *ngIf="!loading && !auditTrailActivities?.length">
    <div class="ts-audit-empty-ico">
      <i class="bi bi-clock-history"></i>
    </div>
    <h3>No activity yet</h3>
    <p>Activity will appear here as this {{ type === 'job' ? 'job' : 'timesheet' }} moves through approvals.</p>
  </div>
</div>
